module.exports = __webpack_public_path__ + "static/media/image1.426fbd62.png";